import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import {
  CustomDateAdapter,
  DD_MM_YYYY_FORMAT
} from '../../login-attempt-search-box/login-attempt-search-box.component';
import { AuditLogSearchFilter } from '../../../../models/auditLogSearchFilter';

@Component({
  selector: 'app-audit-log-search-box',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_FORMAT }
  ],
  templateUrl: './audit-log-search-box.component.html',
  styleUrl: './audit-log-search-box.component.scss'
})
export class AuditLogSearchBoxComponent implements OnInit {
  @Input() isSearchVisible = false;
  /** Pre-populates the form so the list's default filter (current day) is visible and editable. */
  @Input() initialFilter?: AuditLogSearchFilter;
  @Output() auditLogSearchFilter = new EventEmitter<AuditLogSearchFilter>();

  searchForm: AuditLogSearchFilter = {
    changedBy: undefined,
    changedAtFrom: undefined,
    changedAtTo: undefined,
    companyId: undefined
  };

  ngOnInit(): void {
    if (this.initialFilter) {
      this.searchForm = { ...this.searchForm, ...this.initialFilter };
    }
  }

  onSearch(): void {
    this.auditLogSearchFilter.emit({ ...this.searchForm });
  }

  clearSearch(): void {
    this.searchForm = {
      changedBy: undefined,
      changedAtFrom: undefined,
      changedAtTo: undefined,
      companyId: undefined
    };
    this.auditLogSearchFilter.emit({ ...this.searchForm });
  }
}
